import { EXCEL_FORMAT_OPTION, PDF_FORMAT_OPTION } from "../../utilities/Constants";

export default interface IMeasurementSetting {
    id: string;
    isMeanTendency: boolean;
    isStdDeviation: boolean;
    header: string;
    subHeader: string;
    footer: string;
    logo: string;
    fileNamePrefix: string;
    isSaveFormatPdf: boolean;
    reportSaveLocation: string;
    isAutoGenerateReport: boolean;
    isAutoGenerateRealReport: boolean;
    isAutoGenerateValueReport: boolean;
    isAutoGeneratePositionReport: boolean;
    isAutoGenerateGraphReport: boolean;
    selectedGraphType?: any;
}

export  interface IExportOptions{
    key:string,
    value:string,
}

export class MeasurementSetting implements IMeasurementSetting {
    id: string;
    isMeanTendency: boolean;
    meanTendency: number[];
    isStdDeviation: boolean;
    stdDeviation: number[];
    header: string;
    subHeader: string;
    footer: string;
    logo: string;
    fileNamePrefix: string;
    isSaveFormatPdf: boolean;
    saveFormatPdf: string;
    reportSaveLocation: string;
    isAutoGenerateReport: boolean;
    isAutoGenerateRealReport: boolean;
    isAutoGenerateValueReport: boolean;
    isAutoGeneratePositionReport: boolean;
    isAutoGenerateGraphReport: boolean;
    selectedGraphType?: any;
    generateXML?: boolean;
    constructor(id: string,
        isMeanTendency: boolean,
        isStdDeviation: boolean,
        header: string,
        subHeader: string,
        footer: string,
        logo: string,
        fileNamePrefix: string,
        isSaveFormatPdf: boolean,
        reportSaveLocation: string,
        isAutoGenerateReport: boolean,
        isAutoGenerateRealReport: boolean,
        isAutoGenerateValueReport: boolean,
        isAutoGeneratePositionReport: boolean,
        isAutoGenerateGraphReport: boolean,
        selectedGraphType?: any,
        generateXML?: boolean
    ) {
        this.id = id;
        this.isMeanTendency = isMeanTendency;

        this.isStdDeviation = isStdDeviation;

        this.header = header;
        this.subHeader = subHeader;
        this.footer = footer;
        this.logo = logo;
        this.fileNamePrefix = fileNamePrefix;
        this.isSaveFormatPdf = isSaveFormatPdf;
        this.reportSaveLocation = reportSaveLocation;
        this.isAutoGenerateReport = isAutoGenerateReport;
        this.isAutoGenerateRealReport = isAutoGenerateRealReport;
        this.isAutoGenerateValueReport = isAutoGenerateValueReport;
        this.isAutoGeneratePositionReport = isAutoGeneratePositionReport;
        this.isAutoGenerateGraphReport = isAutoGenerateGraphReport;

        this.saveFormatPdf = isSaveFormatPdf ? PDF_FORMAT_OPTION : EXCEL_FORMAT_OPTION;
        this.meanTendency = isMeanTendency ? [0] : [1];
        this.stdDeviation = isStdDeviation ? [0] : [1];
        this.selectedGraphType = selectedGraphType;
        this.generateXML = generateXML;
    }
}

const defaultMeasurementSettingData = new MeasurementSetting("", false, false, "", "", "", "", "", false, "", false, false, false, false, false, {});
export { defaultMeasurementSettingData }